import axios from 'axios'
import {
  ChurnSurveyReasonsResponse,
  OrganizationSaasTierResponse,
  OrganizationUsagesResponse,
  SubscriptionResponse,
} from 'src/models/organizations.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

// Read functions return response.data and let axios errors propagate untouched so
// the preserved useQueryXxx wrappers can reproduce useExtendQuery's exact
// `error: axiosError.response?.data` contract (see toBackendError in saas.queries).

export const getOrganizationSaasTier = async (
  orgId: string,
): Promise<OrganizationSaasTierResponse> => {
  const { data } = await axios.get<OrganizationSaasTierResponse>(
    `saas/${orgId}/tier`,
    getRequestConfig(RequestConfig.Default),
  )
  return data
}

export const getOrganizationUsages = async (
  orgId: string,
): Promise<OrganizationUsagesResponse> => {
  const { data } = await axios.get<OrganizationUsagesResponse>(
    `saas/${orgId}/usages`,
    getRequestConfig(RequestConfig.Default),
  )
  return data
}

export const getOrganizationSubscription = async (
  orgId: string,
): Promise<SubscriptionResponse> => {
  const { data } = await axios.get<SubscriptionResponse>(
    `saas/${orgId}/subscription`,
    getRequestConfig(RequestConfig.Default),
  )
  return data
}

export const getChurnSurveyReasons = async (
  orgId: string,
): Promise<ChurnSurveyReasonsResponse> => {
  const { data } = await axios.get<ChurnSurveyReasonsResponse>(
    `saas/${orgId}/churnsurvey/reasons`,
    getRequestConfig(RequestConfig.Default),
  )
  return data
}
